<template>
    <div class="one-to-one__section">

        <h2 class="one-to-one__section-title">{{ $t("is-the-timing-good") }}</h2>

        <template v-if="!dataError">
            <h3 class="title--inline">{{ subtitle }}</h3>
            <template v-if="currentViewType === 'week'">
                <button
                    @click="currentViewType = 'year'"
                    class="button button--primary">{{ $t("view-per-year") }}</button>
            </template>
            <template v-else>
                <button
                    @click="currentViewType = 'week'"
                    class="button button--primary">{{ $t("view-per-week") }}</button>
            </template>


            <div class="grid">
                <div class="grid__item desktop--6">

                    <template v-if="currentViewType === 'week'">
                        <TimingEvolutionChart
                            type="Love-transit"
                            category="Love-transit-day"
                            period-type="week"
                            :current-week="currentWeek"
                            :data="partnerTimeline"
                            :title="partnerTitleWeek"
                            :subtitle="partnerSubtitleWeek"
                            @error="handleDataError"
                            @update-title="updatePartnerTitleType"/>
                    </template>
                    <template v-else>
                        <TimingEvolutionChart
                            type="Love-transit"
                            category="Love-transit-year"
                            period-type="year"
                            :current-week="currentWeek"
                            :data="partnerTimeline"
                            :title="partnerTitleYear"
                            :subtitle="partnerSubtitleYear"
                            @error="handleDataError"
                            @update-title="updatePartnerTitleType" />
                    </template>

                </div>
                <div class="grid__item desktop--6">

                    <template v-if="currentViewType === 'week'">
                        <TimingEvolutionChart
                            type="Love-transit"
                            category="Love-transit-day"
                            period-type="week"
                            :current-week="currentWeek"
                            :data="userTimeline"
                            :title="userTitleWeek"
                            :subtitle="userSubtitleWeek"
                            @error="handleDataError"
                            @update-title="updateUserTitleType" />
                    </template>
                    <template v-else>
                        <TimingEvolutionChart
                            type="Love-transit"
                            category="Love-transit-year"
                            period-type="year"
                            :current-week="currentWeek"
                            :data="userTimeline"
                            :title="userTitleYear"
                            :subtitle="userSubtitleYear"
                            @error="handleDataError"
                            @update-title="updateUserTitleType" />
                    </template>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="one-to-one__section-error">
                <p>{{ $t("section-timing-data-error") }}</p>
            </div>
        </template>

        <p class="title--4">
            <template v-if="currentViewType === 'week'">
                {{ $t("select-a-past-date-to-check-the-timing-week") }}
            </template>
            <template v-else>
                {{ $t("select-a-past-date-to-check-the-timing-year") }}
            </template>
        </p>
        <div class="grid">
            <div
                class="grid__item"
                :class="{'desktop--4': currentViewType === 'week', 'desktop--2': currentViewType === 'year'}">
                <div class="field">
                    <div class="field--select-group">
                        <field-select
                            v-if="currentViewType === 'week'"
                            :value="selectedDay"
                            name="selectedDay"
                            id="field-selected-day"
                            input-label-id="field-selected-day-label"
                            @update-value="updateSelectedDay"
                            :options="[
                                {'value': '01', 'label': '1'},
                                {'value': '02', 'label': '2'},
                                {'value': '03', 'label': '3'},
                                {'value': '04', 'label': '4'},
                                {'value': '05', 'label': '5'},
                                {'value': '06', 'label': '6'},
                                {'value': '07', 'label': '7'},
                                {'value': '08', 'label': '8'},
                                {'value': '09', 'label': '9'},
                                {'value': '10', 'label': '10'},
                                {'value': '11', 'label': '11'},
                                {'value': '12', 'label': '12'},
                                {'value': '13', 'label': '13'},
                                {'value': '14', 'label': '14'},
                                {'value': '15', 'label': '15'},
                                {'value': '16', 'label': '16'},
                                {'value': '17', 'label': '17'},
                                {'value': '18', 'label': '18'},
                                {'value': '19', 'label': '19'},
                                {'value': '20', 'label': '20'},
                                {'value': '21', 'label': '21'},
                                {'value': '22', 'label': '22'},
                                {'value': '23', 'label': '23'},
                                {'value': '24', 'label': '24'},
                                {'value': '25', 'label': '25'},
                                {'value': '26', 'label': '26'},
                                {'value': '27', 'label': '27'},
                                {'value': '28', 'label': '28'},
                                {'value': '29', 'label': '29'},
                                {'value': '30', 'label': '30'},
                                {'value': '31', 'label': '31'},
                            ]" />
                        <field-select
                            v-if="currentViewType === 'week'"
                            :value="selectedMonth"
                            name="selectedMonth"
                            id="field-selected-month"
                            input-label-id="field-selected-month-label"
                            @update-value="updateSelectedMonth"
                            :options="[
                                {'value': '01', 'label': '1'},
                                {'value': '02', 'label': '2'},
                                {'value': '03', 'label': '3'},
                                {'value': '04', 'label': '4'},
                                {'value': '05', 'label': '5'},
                                {'value': '06', 'label': '6'},
                                {'value': '07', 'label': '7'},
                                {'value': '08', 'label': '8'},
                                {'value': '09', 'label': '9'},
                                {'value': '10', 'label': '10'},
                                {'value': '11', 'label': '11'},
                                {'value': '12', 'label': '12'},
                            ]" />
                        <field-select
                            name="selectedYear"
                            :value="selectedYear"
                            id="field-selected-year"
                            input-label-id="field-selected-year-label"
                            @update-value="updateSelectedYear"
                            :options="years" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Vue from "vue";
import dayjs from "dayjs";

import FieldSelect from "@/components/forms/FieldSelect.vue";
import TimingEvolutionChart from "@/components/charts/TimingEvolutionChart.vue";

import { getRangeOfYear } from "@/utils/utils.js";
import { pad } from "@/utils/helpers/string.js";


export default {
    name: "TimingSection",
    components: {
        "FieldSelect": FieldSelect,
        "TimingEvolutionChart": TimingEvolutionChart
    },
    props: {
        userTimeline: {
            type: Array,
            required: true
        },
        partnerTimeline: {
            type: Array,
            required: true
        },
    },
    data () {
        return {
            partnerTitleType: null,
            userTitleType: null,
            currentViewType: "week",
            selectedDay: String(pad(dayjs().date())),
            selectedMonth: String(pad(dayjs().month() + 1)),
            selectedYear: new Date().getFullYear(),
            dataError: false
        };
    },
    computed: {
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        totalYears() {
            return getRangeOfYear(new Date(this.loggedUser.bdate).getFullYear(), new Date().getFullYear());
        },
        subtitle() {
            if (this.currentViewType === "year") {
                return this.$t("year-ambiant");
            }

            return this.$t("week-ambiant");
        },
        years() {
            let array = [];

            this.totalYears.map((year) => {
                array.push({
                    "value": year.toString(),
                    "label": year.toString()
                });
            });

            return array;
        },
        currentWeek() {
            const currentDate = `${this.selectedYear}-${this.selectedMonth}-${this.selectedDay}`;

            return currentDate;
        },
        partnerTitleWeek() {
            if (this.partnerTitleType) {
                return this.$t(`partner-evolution-week-title-${this.partnerTitleType}`);
            }

            return "";
        },
        partnerSubtitleWeek() {
            if (this.partnerTitleType) {
                return this.$t(`partner-evolution-week-subtitle-${this.partnerTitleType}`);
            }

            return "";
        },
        userTitleWeek() {
            if (this.userTitleType) {
                return this.$t(`user-evolution-week-title-${this.userTitleType}`);
            }

            return "";
        },
        userSubtitleWeek() {
            if (this.userTitleType) {
                return this.$t(`user-evolution-week-subtitle-${this.userTitleType}`);
            }

            return "";
        },
        partnerTitleYear() {
            if (this.partnerTitleType) {
                return this.$t(`partner-evolution-year-title-${this.partnerTitleType}`);
            }

            return "";
        },
        partnerSubtitleYear() {
            if (this.partnerTitleType) {
                return this.$t(`partner-evolution-year-subtitle-${this.partnerTitleType}`);
            }

            return "";
        },
        userTitleYear() {
            if (this.userTitleType) {
                return this.$t(`user-evolution-year-title-${this.userTitleType}`);
            }

            return "";
        },
        userSubtitleYear() {
            if (this.userTitleType) {
                return this.$t(`user-evolution-year-subtitle-${this.userTitleType}`);
            }

            return "";
        },
    },
    watch: {
        currentWeek(newVal, oldVal) {
            this.dataError = false;
        }
    },
    mounted: function() {
    },
    methods: {
        updateSelectedDay(value) {
            this.selectedDay = value;
        },
        updateSelectedMonth(value) {
            this.selectedMonth = value;
        },
        updateSelectedYear(value) {
            this.selectedYear = value;
        },
        updatePartnerTitleType(value) {
            this.partnerTitleType = value;
        },
        updateUserTitleType(value) {
            this.userTitleType = value;
        },
        handleDataError(value) {
            this.dataError = value;
        }
    }
};

</script>